import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Icon from '@material-ui/core/Icon';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link as RouterLink, match, RouteComponentProps } from 'react-router-dom';

import { Add } from '@material-ui/icons';
// Components
import { LCAlert } from '../../../../components/alert';
import App from '../../../../components/app';
import { ActionFunction, FormatType, HeadCell } from '../../../../local-types';
import { Dialog } from '../../../../components/dialog';
import { DialogTextColor } from '../../../../components/dialog/dialog';
import ErrorMessage from '../../../../components/error-message';
import { AutoFill } from '../../../../components/field-autofill';
import EnhancedTable from '../../../../components/table';
import MyLink from '../../../../components/mylink/mylink';
import CustomizedTreeView from '../../../../components/customTree/customTree';
import FastTabs, { TabsDatas } from '../../../../components/tabs/tabs';
import { TooltipButton } from '../../../../components/tooltip-button';
import Listing from '../../../../components/listing';
import FormSubmit from '../../../../components/form/formSubmit';
// Modules
import {
    PricingCompany,
    Set as PricingSetDetail,
    SetByID,
    Tariff,
    TariffArrayByID,
    ComputedPrice,
    CompanyToPricingSet,
    Price,
    PriceExplain,
    PriceExplainField,
    PriceExplainLeg,
    PriceExplainPricingSet,
    PriceExplainScope,
    PriceExplainTariff,
    TParams,
} from '../../../../redux/reducers/api-types';
import { tableRequestPoints, makeMemoizedGetDatas } from '../../../../redux/reducers/table/module';
import { ErrorPayload, actions as errorActions, selectors as errorSelectors } from '../../../../redux/reducers/errors';
import { selectors as pendingSelectors } from '../../../../redux/reducers/pendingOperations';
import {
    actions as pricingActions,
    selectors as pricingSelectors,
    types as pricingTypes,
} from '../../../../redux/reducers/pricing';
// Ressources
import debounce from 'lodash/debounce';
import CSVUtils from '../../../../utils/csvUtils';
import FormattingUtils from '../../../../utils/formattingUtils';
import ObjectUtils from '../../../../utils/objectUtils';
import StringUtils from '../../../../utils/stringUtils';
import withGlobalStyles from '../../../../utils/global-styles';
import htmlUtils, { clsx } from '../../../../utils/htmlUtils';
import UserUtils, { AccountRight, RightRank } from '../../../../utils/userUtils';
import DateUtils from '../../../../utils/dateUtils';
import { paths } from '../../../paths';
import { ActionLogs } from '../../../../components/action-logs';
import MainLoading from '../../../../components/main-loading/main-loading';
import { getGeoAutocompleteURL, getListCompaniesURL } from '../../../../utils/core-api';
import { Cell, createCell } from '../../../../components/table/table-cell-creator';

/** A pricing set of the explain chain, nested as CustomizedTreeView expects it. */
interface ExplainSetNode extends PriceExplainPricingSet {
    children: ExplainSetNode[];
}

/**
 * The explain panel renders one table per scope, and a table sizes its columns from
 * its own content: two blocks holding the same four columns came out with different
 * column widths, which reads as if they were different tables. Fixing the geometry
 * here makes every block line up, whatever it contains.
 */
const EXPLAIN_COLUMN_WIDTHS = ['22%', '23%', '15%', '40%'];

interface PricingPricesViewProps extends WithTranslation, RouteComponentProps {
    match: match<TParams>;
    globalClasses: any;
    sets: SetByID;
    companyToPricingSetsList: CompanyToPricingSet[];
    tariffs: TariffArrayByID;
    price: ComputedPrice | null;
    getTariffsError: ErrorPayload;
    pricingSetActionsError: ErrorPayload;
    getPricingSetError: ErrorPayload;
    getComputePriceError: ErrorPayload;
    updateCompanyPricingSetsError: ErrorPayload;
    updateGroupPricingSetsError: ErrorPayload;
    createGroupToPricingSets: (idc, pricing_set, payload, callback?) => any;
    deleteGroupToPricingSets: (id, idp, idc, callback?) => any;
    prices: Price[];
    getPricingSets: () => void;
    isComputingTariff: boolean;
    getPricingSet: (id: string) => void;
    exportPricingSet: (id: string, callback: any /*React.EffectCallback*/) => void;
    importPricingSet: (id: string, payload: any, callback: React.EffectCallback) => void;
    deletePricingSet: (id: string, parent_id?: string) => void;
    createCompanyToPricingSets: (company: any, payload: any, callback?: React.EffectCallback) => void;
    deleteCompanyToPricingSets: (
        id: string,
        company_to_pricing_set_id: string,
        idc?: string,
        callback?: React.EffectCallback,
    ) => void;
    computeTariff: (payload: any) => void;
    resetLocalTariff: () => void;
    searchTariffs: (payload: any) => void;
    deleteTariff: (pricing_set_id: string, tariff_id: string) => void;
    clearError: (errorType: string) => void;
}

interface PricingPricesViewState {
    modeAdd: boolean;
    text: string;
    idc: any;
    company: any;
    formData: any;
    csvMsg: string;
    tariffFilters: { [label: string]: string };
}

const MANAGE_PRICES = paths.pricingManagePrices + '/';

class PricingPricesViewPage extends React.Component<PricingPricesViewProps, PricingPricesViewState> {
    alertRef: any;
    tableRef: any;
    groupTableRef: any;
    deleteDialogRef: any;
    inputElement: any;
    isAdmin: boolean;

    constructor(props: PricingPricesViewProps) {
        super(props);
        const { match } = props;
        this.isAdmin = UserUtils.checkRightsOrAdmin({ name: AccountRight.PRICING_MGMT, mode: RightRank.W });
        this.state = {
            modeAdd: false,
            text: '',
            idc: -1,
            company: null,
            csvMsg: '',
            tariffFilters: {},
            formData: {
                pricing_set_id: match.params.id,
            },
        };
    }

    componentDidMount() {
        const { match, getPricingSet, searchTariffs, getPricingSets } = this.props;
        const id = match.params.id;
        getPricingSet(id);
        searchTariffs({ pricing_set_id: id });
        // Backs the cascade preview below: descendants are computed from the
        // flat list rather than asked for, there being no endpoint for them.
        getPricingSets();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params.id !== (this.props.match.params as any).id) {
            const id = this.props.match.params.id;
            this.props.getPricingSet(id);
        }
    }

    componentWillUnmount() {
        this.props.resetLocalTariff();
    }

    //========================================//
    //=============== Handlers ===============//
    //========================================//

    // Autocomplete
    /**
     * Attach this sheet to whatever was picked - company or departement.
     *
     * The picker is fed by _SCBO_company_subcompany_get_all, which returns
     * both, and the two are stored in different places: a company links through
     * company_to_pricing_set, a departement through group_to_pricing_set. Only
     * companies have a row in pricing, so posting a departement to the company
     * endpoint failed the foreign key with a 422 that explained nothing.
     *
     * The list endpoint now carries the parent, which is both the discriminator
     * and the name of the owning company.
     */
    handleAddCompanySubmit = (event): void => {
        event.preventDefault();

        const { match, companyToPricingSetsList, createCompanyToPricingSets, createGroupToPricingSets } = this.props;
        const { idc, company } = this.state;
        const id = match.params.id;

        if (!(idc > 0) || !company) {
            return;
        }

        // Presence of a parent is what makes it a departement. Deliberately not
        // a discriminator string: 'dept' is the value in the database, the API
        // alias is 'department', and the first version of this compared against
        // the wrong one - a mistake a truthiness check cannot make.
        if (company.parent) {
            // The duplicate check below guards the company table; the group
            // table is a different list, and pricing enforces one live sheet
            // per group and service anyway.
            createGroupToPricingSets(null, null, { pricing_set_id: id, group_id: company.uuid }, () => {
                this.groupTableRef?.reload();
                this.setState({ idc: -1, text: '', company: null });
            });
            return;
        }

        //Check if idc (company id) is set and that it doesn't exist already
        if (companyToPricingSetsList && companyToPricingSetsList.findIndex((x) => x.company_id === idc) === -1) {
            createCompanyToPricingSets(
                company,
                {
                    pricing_set_id: id,
                    company_id: company.uuid,
                },
                () => {
                    this.tableRef.reload();
                },
            );
        }
    };

    /**
     * AutoFill writes the picked place straight into `formData`, which is a
     * mutation React cannot see: without this the button would keep the look it
     * had when the panel last rendered. Re-rendering here is what makes it
     * light up as soon as both addresses are set.
     *
     * Clearing a field is signalled with a synthetic event and no place, and
     * AutoFill does not clear `formData` itself - so drop the stale address
     * here, otherwise the test would keep computing on an address the operator
     * can no longer see.
     */
    handlePricingAddressChange =
        (field: string) =>
        (event, place?): void => {
            const { formData } = this.state;
            if (place) {
                formData[field] = place;
            } else {
                delete formData[field];
            }
            this.setState({ formData });
        };

    handlePricingTest = (event): void => {
        event.preventDefault();
        this.props.clearError(pricingTypes.COMPUTE_TARIFF);

        const { formData } = this.state;

        if (formData.pu && formData.do) {
            // formatting data
            const extractLoc = (obj) => ({
                lat: obj?.location?.[0],
                lng: obj?.location?.[1],
            });

            const payload = {
                start_location: formData?.pu?.place_id, // extractLoc(formData.pu)
                end_location: formData?.do?.place_id, // extractLoc(formData.do)
                ...(formData.start_date && {
                    date: DateUtils.stringToTs(formData.start_date) * 1000,
                }),
                // date: formData.start_date,
                pricing_set_id: formData.pricing_set_id,
            };

            this.props.computeTariff(payload);
        }
    };

    handleDelete = (obj: PricingCompany) => (e) => {
        const { match, deleteCompanyToPricingSets } = this.props;
        const id: string = match.params.id;
        if (obj?.id) {
            deleteCompanyToPricingSets(id, obj.id, null, () => {
                this.tableRef.reload();
            });
        } else {
            console.error("Can't delete", obj);
        }
    };

    /**
     * Detach a departement from this sheet.
     *
     * The row id is the group_to_pricing_set link, not the group - deleting is
     * removing the link, and the sheet and the departement both survive it.
     */
    handleDeleteGroup = (obj: any) => () => {
        const { match, deleteGroupToPricingSets } = this.props;
        const id: string = match.params.id;
        if (obj?.id) {
            deleteGroupToPricingSets(id, obj.id, null, () => {
                this.groupTableRef?.reload();
            });
        } else {
            console.error("Can't delete", obj);
        }
    };

    handleDeleteTariff =
        (index, ...objs: Tariff[]) =>
        () => {
            const { match } = this.props;
            const id: string = match.params.id;
            objs.filter(Boolean).forEach((obj) => this.props.deleteTariff(id, obj.id));
        };

    handleModeAdd = (): void => {
        this.setState((prevState) => ({ modeAdd: !prevState.modeAdd }));
    };

    onChangeFile = (event): void => {
        event.stopPropagation();
        event.preventDefault();
        const file = event.target.files[0];
        CSVUtils.getDataFromCSVFile(file, (csv, error, msg) => {
            if (!error) {
                this.alertRef.closeAlert();
                const { match, importPricingSet, searchTariffs } = this.props;
                const id: string = match.params.id;
                importPricingSet(id, { delete_existing: true, data: csv }, () => {
                    searchTariffs({ pricing_set_id: id });
                });
            } else {
                this.setState(
                    {
                        csvMsg: msg,
                    },
                    () => {
                        this.alertRef.showAlert();
                    },
                );
            }
        });
    };

    //========================================//
    //=============== Builders ===============//
    //========================================//

    /**
     * Every sheet that a delete would take with it.
     *
     * Deleting a sheet soft-deletes its whole subtree by parent_id, and group
     * sheets are children of the company sheet they override - so deleting a
     * company sheet destroys the tariffs of every departement below it.
     */
    descendantSheets = (id: string): Price[] => {
        const { prices } = this.props;
        if (!prices?.length) {
            return [];
        }
        const byParent = new Map<string, Price[]>();
        prices.forEach((p) => {
            if (!p.parent_id) {
                return;
            }
            byParent.set(p.parent_id, [...(byParent.get(p.parent_id) ?? []), p]);
        });

        const out: Price[] = [];
        const seen = new Set<string>([id]);
        const queue = [id];
        while (queue.length) {
            const current = queue.shift();
            (byParent.get(current) ?? []).forEach((child) => {
                if (seen.has(child.id)) {
                    return;
                }
                seen.add(child.id);
                out.push(child);
                queue.push(child.id);
            });
        }
        return out;
    };

    deleteDescription = (id: string): string => {
        const { t, prices } = this.props;
        const children = this.descendantSheets(id);
        if (!children.length) {
            // Says so explicitly: an empty list here and a list that could not
            // be loaded must not look the same.
            return prices?.length ? t('sets.delete_confirm_no_children') : t('sets.delete_confirm_unknown');
        }
        return `${t('sets.delete_confirm_children', { count: children.length })}\n${children
            .map((c) => `- ${c.name}`)
            .join('\n')}`;
    };

    generateActions = (datas: any): ActionFunction[] => {
        const { t, match } = this.props;
        const id = match.params.id;
        const actions: ActionFunction[] = [];
        if (this.isAdmin) {
            actions.push({
                label: t('common:edit'),
                func: () => this.props.history.push(`${MANAGE_PRICES}add?id=${id}`),
            });

            actions.push({
                label: t('common:import'),
                func: () => {
                    this.inputElement.click();
                },
            });

            actions.push({
                label: t('common:export'),
                func: () =>
                    this.props.exportPricingSet(id, (dispatch, response) => {
                        const csvData = CSVUtils.getCSVfromData(response.payload);
                        htmlUtils.createDownloadAction(csvData, 'text/csv', `export_pricing_${id}`);
                    }),
            });

            actions.push({
                label: t('common:delete'),
                // Was an unconfirmed delete that cascades over the subtree.
                func: () => this.deleteDialogRef?.showDialog(),
                style: { color: 'red' },
            });
        }
        return actions;
    };

    createChildren = (title, to, add, datas) => {
        const { t, globalClasses, match, getTariffsError } = this.props;
        const id = match.params.id;

        return (
            <div className={globalClasses.blockSpacing}>
                <div style={{ marginBottom: 30 }}>{title}</div>
                {this.isAdmin && (
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 30 }}>
                        <TooltipButton title={t('common:add')}>
                            <Button
                                size="small"
                                style={{ marginLeft: 20, marginRight: 14 }}
                                variant="contained"
                                color="primary"
                                component={RouterLink}
                                to={`${MANAGE_PRICES}${id}/${to}`}
                                className={clsx(globalClasses.btnAutoWidth, globalClasses.btnSuccess)}
                                aria-label="action"
                            >
                                <AddIcon />
                            </Button>
                        </TooltipButton>
                        <b>{add}</b>
                    </div>
                )}
                <ErrorMessage payload={getTariffsError} />
                <Listing datas={datas} />
            </div>
        );
    };

    renderDeleteTariff = (index: number, toDelete: Tariff[], title: string, areas: string): React.JSX.Element => {
        const { t, globalClasses } = this.props;
        return (
            <Dialog
                btnTitle={t('common:validate')}
                description={t('common:deleteParam', {
                    id: `(${toDelete.map((x) => x.id).join(', ')}) ${areas}`,
                })}
                customButton={
                    <TooltipButton title={title}>
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                        >
                            <Icon fontSize="small">delete</Icon>
                        </Button>
                    </TooltipButton>
                }
                onOK={this.handleDeleteTariff(index, ...toDelete)}
            />
        );
    };

    // reverse: set when the same tariff also exists in the other way, both are then shown as a single row
    createPriceView(tariff: Tariff, to: string, id: string, index: number, reverse?: Tariff): React.JSX.Element {
        const { t } = this.props;
        const wayLabel = (one: Tariff): string =>
            `${one?.start_area?.name}${one?.end_area?.name ? ` -> ${one?.end_area?.name}` : ''}`;
        const areas: string = reverse ? `${tariff?.start_area?.name} <-> ${tariff?.end_area?.name}` : wayLabel(tariff);

        return (
            <div key={tariff.id} style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <MyLink
                        color="secondary"
                        style={{ marginRight: 8, flex: 1 }}
                        // both_ways pre-checks the "both ways" box, to keep the pair in sync when edited from a merged row
                        to={`${MANAGE_PRICES}${id}/${to}?edit_id=${tariff.id}${reverse ? '&both_ways=1' : ''}`}
                    >
                        {`${t('tariffs.title')} ${areas}`}
                    </MyLink>
                    {this.isAdmin &&
                        this.renderDeleteTariff(
                            index,
                            reverse ? [tariff, reverse] : [tariff],
                            reverse ? t('tariffs.delete_both_ways') : t('common:delete'),
                            areas,
                        )}
                </div>
                {/* Each way of a merged row gets its own line, to stay editable and deletable on its own */}
                {reverse &&
                    [tariff, reverse].map((oneWay) => (
                        <div
                            key={oneWay.id}
                            style={{ display: 'flex', alignItems: 'center', marginTop: 8, paddingLeft: 24 }}
                        >
                            <MyLink
                                color="secondary"
                                style={{ marginRight: 8, flex: 1 }}
                                to={`${MANAGE_PRICES}${id}/${to}?edit_id=${oneWay.id}`}
                            >
                                {wayLabel(oneWay)}
                            </MyLink>
                            {this.isAdmin &&
                                this.renderDeleteTariff(index, [oneWay], t('tariffs.delete_one_way'), wayLabel(oneWay))}
                        </div>
                    ))}
            </div>
        );
    }

    // A flat rate priced the same in both ways is displayed as a single "start <-> end" row
    createFlatRateViews = (tariffs: Tariff[], id: string): React.JSX.Element[] => {
        const alreadyMerged: string[] = [];
        return tariffs.reduce((views, tariff, index) => {
            if (alreadyMerged.includes(tariff.id)) {
                return views;
            }
            const reverse: Tariff = tariffs.find(
                (x) =>
                    x.id !== tariff.id &&
                    !alreadyMerged.includes(x.id) &&
                    x.start_area?.id === tariff.end_area?.id &&
                    x.end_area?.id === tariff.start_area?.id &&
                    ObjectUtils.isEqual(x.pricing_params, tariff.pricing_params),
            );
            if (reverse) {
                alreadyMerged.push(reverse.id);
            }
            return [...views, this.createPriceView(tariff, 'new_tarif_forfait', id, index, reverse)];
        }, []);
    };

    generateTabs = (): TabsDatas => {
        const { t, tariffs, match, getTariffsError } = this.props;
        const id = match.params.id;

        const tabs: TabsDatas = {
            storageKey: 'pricing-view-tariff-tab',
            datas: [
                {
                    label: t('sets.horokm'),
                    children: this.createChildren(
                        t('sets.desc_km'),
                        `new_tarif_hkm`,
                        t('sets.add_km'),
                        tariffs?.[id] &&
                            tariffs[id]
                                .filter((x) => x.type === 'horokilometric')
                                .map((tariff, index) => {
                                    return this.createPriceView(tariff, 'new_tarif_hkm', id, index);
                                }),
                    ),
                },
                {
                    label: t('sets.forfait'),
                    children: this.createChildren(
                        t('sets.desc_forfait'),
                        `new_tarif_forfait`,
                        t('sets.add_forfait'),
                        tariffs?.[id] &&
                            this.createFlatRateViews(
                                tariffs[id].filter((x) => x.type === 'flat_rate'),
                                id,
                            ),
                    ),
                },
                {
                    label: t('sets.dispo'),
                    children: this.createChildren(
                        t('sets.desc_dispo'),
                        `new_tarif_dispo`,
                        t('sets.add_dispo'),
                        tariffs?.[id] &&
                            tariffs[id]
                                .filter((x) => x.type === 'provision')
                                .map((tariff, index) => {
                                    return this.createPriceView(tariff, 'new_tarif_dispo', id, index);
                                }),
                    ),
                },
            ],
        };
        return tabs;
    };

    /**
     * Group links, by id.
     *
     * The company table opposite resolves names because pricing holds a
     * company table to join; there is no group registry there, so the id is
     * genuinely all this endpoint can return.
     */
    groupHeaderBuilder = (): HeadCell[] => {
        const { t, globalClasses } = this.props;
        const cells: HeadCell[] = [
            createCell(t, Cell.ID, { sortable: true }),
            {
                id: 'created_at',
                label: t('common:table.creation_date'),
                contains: false,
                filterable: false,
                type: FormatType.DateLong,
            },
            {
                id: 'group_id',
                label: t('sets.group'),
                sortable: false,
                filterable: false,
                // The webservice proxy resolves the uuid to the departement and
                // its parent company; pricing itself holds no group registry, so
                // the raw uuid is all it can return and is the fallback here.
                // It stays visible rather than becoming 'N/A' - an id you can
                // search for beats a placeholder that hides one.
                formatCell: (row) =>
                    row.group?.id ? (
                        <span>
                            <Link color="secondary" component={RouterLink} to={`${paths.companies}/${row.group.id}`}>
                                {row.group.name}
                            </Link>
                            {row.group.parent?.name && (
                                <span style={{ color: '#757575' }}>{` (${row.group.parent.name})`}</span>
                            )}
                        </span>
                    ) : (
                        row.group_id
                    ),
            },
            {
                id: 'start_date',
                label: t('sets.start_date'),
                sortable: false,
                filterable: false,
                type: FormatType.DateLong,
            },
            {
                id: 'end_date',
                label: t('sets.end_date'),
                sortable: false,
                filterable: false,
                type: FormatType.DateLong,
            },
        ];
        if (this.isAdmin) {
            cells.push({
                id: 'action',
                label: t('common:action'),
                sortable: false,
                filterable: false,
                formatCell: (row) => {
                    return (
                        <Dialog
                            btnTitle={t('common:validate')}
                            description={t('common:deleteParam', {
                                // The group is resolved by the proxy; fall back to the
                                // raw uuid for a group it could not resolve, the same
                                // way the column itself does.
                                id: row?.group ? `(${row.group.id}) ${row.group.name}` : row.group_id,
                            })}
                            customButton={
                                <TooltipButton title={t('common:delete')}>
                                    <Button
                                        size="small"
                                        style={{ marginLeft: 8 }}
                                        variant="contained"
                                        color="primary"
                                        className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                                    >
                                        <Icon fontSize="small">delete</Icon>
                                    </Button>
                                </TooltipButton>
                            }
                            onOK={this.handleDeleteGroup(row)}
                        />
                    );
                },
            });
        }
        return cells;
    };

    headerBuilder = (): HeadCell[] => {
        const { t, globalClasses } = this.props;
        const cells: HeadCell[] = [
            createCell(t, Cell.ID, { sortable: true }),
            {
                id: 'created_at',
                label: t('common:table.creation_date'),
                contains: false,
                filterable: false,
                type: FormatType.DateLong,
            },
            {
                id: 'company_id',
                label: t('common:form.company'),
                sortable: false,
                type: FormatType.Autocomplete,
                api: getListCompaniesURL(),
                formatCell: function (row) {
                    return row.company?.id ? (
                        <Link color="secondary" component={RouterLink} to={`${paths.companies}/${row.company.id}`}>
                            {row.company.name}
                        </Link>
                    ) : (
                        'N/A'
                    );
                },
            },
        ];
        if (this.isAdmin) {
            cells.push({
                id: 'action',
                label: t('common:action'),
                sortable: false,
                filterable: false,
                formatCell: (row) => {
                    return (
                        <Dialog
                            btnTitle={t('common:validate')}
                            description={t('common:deleteParam', {
                                id: row?.company ? `(${row?.company?.id}) ${row?.company?.name}` : row.id,
                            })}
                            customButton={
                                <TooltipButton title={t('common:delete')}>
                                    <Button
                                        size="small"
                                        style={{ marginLeft: 8 }}
                                        variant="contained"
                                        color="primary"
                                        className={clsx(globalClasses.btnAutoWidth, globalClasses.btnDanger)}
                                    >
                                        <Icon fontSize="small">delete</Icon>
                                    </Button>
                                </TooltipButton>
                            }
                            onOK={this.handleDelete(row)}
                        />
                    );
                },
            });
        }
        return cells;
    };

    //=======================================//
    //=============== Renders ===============//
    //=======================================//

    renderPriceTesting = (): JSX.Element => {
        const { formData } = this.state;
        const { t, getComputePriceError, price, globalClasses, isComputingTariff } = this.props;

        const autofillProps: any = {
            location: true,
            locationNoDetails: true,
            minChar: 3,
            style: { flex: 1, marginRight: 8 },
            formData: formData,
            variant: 'outlined',
        };

        const canComputePrice = !!formData.pu && !!formData.do;

        return (
            <FormSubmit debounceSubmit={{ callback: this.handlePricingTest }}>
                <div className={globalClasses.block}>
                    <h3>
                        <b>{t('sets.pricing_test')}</b>
                    </h3>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <AutoFill
                            datas={{
                                id: 'pu',
                                label: t('sets.address_pu'),
                                ...autofillProps,
                                api: getGeoAutocompleteURL(),
                                onChange: this.handlePricingAddressChange('pu'),
                            }}
                        />
                        <AutoFill
                            datas={{
                                id: 'do',
                                label: t('sets.address_do'),
                                ...autofillProps,
                                api: getGeoAutocompleteURL(),
                                onChange: this.handlePricingAddressChange('do'),
                            }}
                        />
                        <FormControl key={'formPricingTest'}>
                            <TextField
                                id={'start_date'}
                                type={'datetime-local'}
                                name={'start_date'}
                                value={formData.start_date ?? ''}
                                // required={true}
                                variant={'outlined'}
                                onChange={(event) => {
                                    formData.start_date = event.target.value;
                                    this.setState({
                                        formData,
                                    });
                                }}
                            />
                        </FormControl>
                        {/* Both addresses are what handlePricingTest actually requires -
                            the date is optional. The button says so rather than staying
                            grey whatever is filled in and silently doing nothing. */}
                        <Button
                            type="submit"
                            variant="contained"
                            // 56px is the height of a default-size outlined input, which is
                            // what the three fields on this row are: the button squares up
                            // with them instead of floating at its own smaller height.
                            style={{ marginLeft: 16, height: 56 }}
                            disabled={!canComputePrice || isComputingTariff}
                            color={canComputePrice ? 'secondary' : 'inherit'}
                        >
                            {t('sets.pricing_calculate')}
                        </Button>
                    </div>
                </div>
                {isComputingTariff && <MainLoading center />}
                {/* Gated on having an answer at all, not on a truthy price:
                    /price/calculate_and_explain answers 200 with a null price and the
                    reason, where /price/calculate would have 422'd. Keying on price?.price
                    swallowed exactly that answer -- the most informative one - LT-1959. */}
                {!isComputingTariff && (getComputePriceError || price) && (
                    <div className={globalClasses.block} style={{ backgroundColor: '#DCE0E4' }}>
                        <ErrorMessage payload={getComputePriceError} />
                        {!getComputePriceError && price?.price != null && (
                            // <TooltipButton title={price.details.map(d => `${d.type} ${d.value} `)}>
                            <span style={{ justifyContent: 'flex-end', display: 'flex' }}>
                                {`${t('sets.pricing_result')}`}
                                <b style={{ marginLeft: 2 }} color="#1542C3">
                                    {FormattingUtils.price(price.price)}
                                </b>
                            </span>
                            // </TooltipButton>
                        )}
                        {/* The engine's own account of why it gave up, in its own words:
                            a raw reason beats a generic sentence in a debugging panel. */}
                        {!getComputePriceError && price && price.price == null && (
                            <span style={{ justifyContent: 'flex-end', display: 'flex' }}>
                                {t('sets.pricing_not_computable')}
                                {!!price.explain?.incomplete_reason && (
                                    <b style={{ marginLeft: 2 }}>{price.explain.incomplete_reason}</b>
                                )}
                            </span>
                        )}
                        {/* On price?.explain alone: a price that failed is the case the
                            explanation is most needed in. */}
                        {!getComputePriceError && price?.explain && this.renderPriceExplain(price.explain)}
                    </div>
                )}
            </FormSubmit>
        );
    };

    //=======================================//
    //=========== Price explain =============//
    //=======================================//

    // Scopes are tariff types, plus cross cutting ones such as surge and waiting.
    explainScopeLabel = (scope: string): string => {
        const { t } = this.props;
        switch (scope) {
            case 'surge':
                return t('sets.explain.scope_surge');
            case 'waiting':
                return t('sets.explain.scope_waiting');
            default:
                return this.tariffTypeLabel(scope);
        }
    };

    explainOriginLabel = (origin: PriceExplainField['origin']): string => {
        const { t } = this.props;
        switch (origin) {
            case 'tariff':
                return t('sets.explain.origin_tariff');
            case 'default':
                return t('sets.explain.origin_default');
            case 'unresolved':
                return t('sets.explain.origin_unresolved');
            default:
                return origin ?? '—';
        }
    };

    // Zone names only live in the request echo, explain tariffs carry area ids.
    // The echo only holds the zones of the journey endpoints, so a leg through an
    // intermediate stop names zones the echo never saw: `fallbackToId` says whether
    // an unknown one is worth showing as a raw id or is better left out.
    explainAreaName = (explain: PriceExplain, areaId: string | null, fallbackToId = true): string | null => {
        if (!areaId) {
            return null;
        }
        const areas = [...(explain.request?.start_areas ?? []), ...(explain.request?.end_areas ?? [])];
        return areas.find((x) => x.id === areaId)?.name ?? (fallbackToId ? areaId : null);
    };

    // "Horokilomètre Puteaux -> Roissy (B2B2C - Berline)": enough to tell two tariffs of the chain apart.
    explainTariffLabel = (explain: PriceExplain, tariff: PriceExplainTariff): string => {
        const areas = [
            this.explainAreaName(explain, tariff.start_area_id),
            this.explainAreaName(explain, tariff.end_area_id),
        ].filter(Boolean);
        const set = explain.pricing_sets?.find((x) => x.id === tariff.pricing_set_id);
        return [this.tariffTypeLabel(tariff.type), areas.join(' -> '), set?.name ? `(${set.name})` : '']
            .filter(Boolean)
            .join(' ');
    };

    // "Trajet 2 Puteaux -> Roissy": a ride with intermediate stops resolves the same
    // horokilometric scope once per leg, so without this the panel shows a row of
    // identical blocks. index is 0 based in the payload, 1 based for the reader.
    explainLegLabel = (explain: PriceExplain, leg: PriceExplainLeg | null): string | null => {
        const { t } = this.props;
        if (!leg) {
            return null;
        }
        const areas = [
            this.explainAreaName(explain, leg.start_area_id, false),
            this.explainAreaName(explain, leg.end_area_id, false),
        ].filter(Boolean);
        return [t('sets.explain.leg', { index: leg.index + 1 }), areas.join(' -> ')].filter(Boolean).join(' ');
    };

    // The inheritance chain, rebuilt from parent_id: the payload lists the sets child first.
    // Rendered through CustomizedTreeView, as the pricing sets list does, and expanded
    // throughout: the chain is the answer to "where does this value come from".
    renderExplainSetsTree = (sets: PriceExplainPricingSet[]): JSX.Element => {
        const { t } = this.props;
        // Emitted ids double as the recursion guard: a parent_id cycle would otherwise
        // both hide its members from the roots and recurse without end.
        const emitted = new Set<string>();
        const build = (nodes: PriceExplainPricingSet[]): ExplainSetNode[] =>
            nodes.reduce((acc: ExplainSetNode[], set) => {
                if (!emitted.has(set.id)) {
                    emitted.add(set.id);
                    acc.push({ ...set, children: build(sets.filter((x) => x.parent_id === set.id)) });
                }
                return acc;
            }, []);
        // A set whose parent is absent from the payload is shown as a root, so that none is
        // dropped; the second pass picks up what a cycle left unreachable, at the root too.
        const roots = sets.filter((x) => !x.parent_id || !sets.some((p) => p.id === x.parent_id));
        const datas = [...build(roots), ...build(sets)];
        const expandedIds = (nodes: ExplainSetNode[]): string[] =>
            nodes.flatMap((node) => (node.children.length ? [node.id, ...expandedIds(node.children)] : []));

        return (
            <div>
                <b>{t('sets.explain.pricing_sets')}</b>
                <CustomizedTreeView
                    datas={datas}
                    expandedIds={expandedIds(datas)}
                    customRow={(row) => (
                        <MyLink color="secondary" to={`${paths.pricingManagePrices}/${row.id}`}>
                            {row.name}
                        </MyLink>
                    )}
                />
            </div>
        );
    };

    // One block per resolution: every parameter the engine resolved, and where it
    // read it from. `index` is the entry's position in explain.params, which is
    // what tells two resolutions of the same scope apart (see PriceExplainScope).
    renderExplainScope = (explain: PriceExplain, scope: PriceExplainScope, index: number): JSX.Element => {
        const { t } = this.props;
        // Tariffs are held once at the root of the payload, keyed by id: the same
        // stack is re-consulted for every scope and every leg.
        const tariffOf = (tariffId: string | null): PriceExplainTariff | undefined =>
            tariffId ? explain.tariffs?.[tariffId] : undefined;
        // Rate tables reach a field as an array: the engine flattens objects, not arrays.
        // Slot-shaped ones (min_price.*, flat_price) get the tariffs table rendering,
        // plain ones (price_per_hour, by rank) are joined so they never read as one number.
        const displayValue = (value: any): string => {
            if (Array.isArray(value)) {
                if (!value.length) {
                    return '—';
                }
                return value.some((x) => x?.time_slot) ? this.slotsLabel(value) : value.join(' / ');
            }
            return value === null || value === undefined || value === '' ? '—' : String(value);
        };

        const leg = this.explainLegLabel(explain, scope.leg);
        return (
            // A discarded resolution priced a branch that was not kept: shown, since
            // "why is this tariff not used" is a question the panel has to answer,
            // but dimmed so it never reads as part of the returned price.
            <div key={`${index}-${scope.scope}`} style={{ marginTop: 16, opacity: scope.discarded ? 0.5 : 1 }}>
                <b>{this.explainScopeLabel(scope.scope)}</b>
                {!!leg && <span style={{ marginLeft: 8 }}>{leg}</span>}
                {scope.discarded && <span style={{ marginLeft: 8 }}>{t('sets.explain.discarded')}</span>}
                <Table size="small" style={{ tableLayout: 'fixed' }}>
                    <colgroup>
                        {EXPLAIN_COLUMN_WIDTHS.map((width) => (
                            <col key={width} style={{ width }} />
                        ))}
                    </colgroup>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('sets.explain.field')}</TableCell>
                            <TableCell>{t('sets.explain.value')}</TableCell>
                            <TableCell>{t('sets.explain.origin')}</TableCell>
                            <TableCell>{t('sets.explain.tariff')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(scope.fields ?? []).map((field) => {
                            const tariff = tariffOf(field.tariff_id);
                            const to = tariff ? this.tariffEditPath(tariff, tariff.pricing_set_id) : null;
                            return (
                                <TableRow key={`${index}-${scope.scope}-${field.field}`}>
                                    {/* Fixed columns cannot widen for a long field name or a raw
                                        area uuid: let those wrap rather than run over the next one. */}
                                    <TableCell style={{ wordBreak: 'break-word' }}>{field.field}</TableCell>
                                    {/* slotsLabel puts one schedule entry per line; without pre-line
                                        HTML collapses them, as the tariffs table already knows. */}
                                    <TableCell style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
                                        {displayValue(field.value)}
                                    </TableCell>
                                    <TableCell>{this.explainOriginLabel(field.origin)}</TableCell>
                                    <TableCell style={{ wordBreak: 'break-word' }}>
                                        {!tariff ? (
                                            '—'
                                        ) : to ? (
                                            <MyLink color="secondary" to={to}>
                                                {this.explainTariffLabel(explain, tariff)}
                                            </MyLink>
                                        ) : (
                                            this.explainTariffLabel(explain, tariff)
                                        )}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </div>
        );
    };

    // Why the computed price is what it is, shown under it when the API returns an explain.
    // Collapsed by default: the price is what is being tested, the breakdown is on demand.
    renderPriceExplain = (explain: PriceExplain): JSX.Element => {
        const { t } = this.props;
        return (
            <Accordion style={{ marginTop: 16 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="price-explain" id="price-explain">
                    <b>{t('sets.explain.title')}</b>
                </AccordionSummary>
                <AccordionDetails style={{ flexDirection: 'column' }}>
                    {/* A truncated params list is otherwise indistinguishable from a full
                        one -- same table, same headings. The producer is explicit that it
                        "must not be read as the full set of tariffs that were considered". */}
                    {explain.complete === false && (
                        <div style={{ marginBottom: 8 }}>
                            <b>{t('sets.explain.incomplete')}</b>
                            {!!explain.incomplete_reason && <span> {explain.incomplete_reason}</span>}
                        </div>
                    )}
                    {!!explain.pricing_sets?.length && this.renderExplainSetsTree(explain.pricing_sets)}
                    {(explain.params ?? []).map((scope, i) => this.renderExplainScope(explain, scope, i))}
                </AccordionDetails>
            </Accordion>
        );
    };

    tariffTypeLabel = (type: string): string => {
        const { t } = this.props;
        switch (type) {
            case 'horokilometric':
                return t('sets.horokm');
            case 'flat_rate':
                return t('sets.forfait');
            case 'provision':
                return t('sets.dispo');
            default:
                return type ?? '—';
        }
    };

    // Edit route per type, matching the links used in the tabs (see createPriceView).
    // setId defaults to the set being viewed, and is passed for a tariff inherited from another set.
    tariffEditPath = (x: Pick<Tariff, 'id' | 'type'>, setId?: string): string | null => {
        const id = setId ?? this.props.match.params.id;
        const toByType: { [key: string]: string } = {
            horokilometric: 'new_tarif_hkm',
            flat_rate: 'new_tarif_forfait',
            provision: 'new_tarif_dispo',
        };
        const to = toByType[x.type];
        return to ? `${MANAGE_PRICES}${id}/${to}?edit_id=${x.id}` : null;
    };

    // Tariffs of the current pricing set, sorted by their (localized) type name.
    sortedTariffs = (): Tariff[] => {
        const { tariffs, match } = this.props;
        const list = tariffs?.[match.params.id] || [];
        return [...list].sort((a, b) => this.tariffTypeLabel(a.type).localeCompare(this.tariffTypeLabel(b.type)));
    };

    // Scheduled arrays (flat_price, min_price.*) hold entries shaped like
    // { time_slot: { mon: [{ start, end }], ... }, value }. Render each entry with its
    // value and the days + hour intervals it applies to (one entry per line). Days sharing
    // the same interval are grouped together and shown as two-letter abbreviations.
    // Shared by the tariffs table and the explain panel, which receives the very same arrays.
    slotsLabel = (arr: any): string => {
        const { t } = this.props;
        const dayOrder = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
        if (!Array.isArray(arr) || !arr.length) {
            return '—';
        }
        return arr
            .map((entry) => {
                const timeSlot = entry?.time_slot || {};
                // Group days by their interval signature to keep the text short.
                const groups: { [intervals: string]: string[] } = {};
                dayOrder.forEach((day) => {
                    const ranges = timeSlot[day];
                    if (Array.isArray(ranges) && ranges.length) {
                        const sig = ranges.map((r: any) => `${r.start}-${r.end}`).join(' ');
                        (groups[sig] = groups[sig] || []).push(day);
                    }
                });
                const schedule = Object.entries(groups)
                    .map(
                        ([intervals, days]) => `${days.map((d) => t('common:days_short.' + d)).join(' ')} ${intervals}`,
                    )
                    .join('; ');
                return schedule ? `${entry.value}€ (${schedule})` : `${entry.value}€`;
            })
            .join('\n');
    };

    // Column definitions shared by the on-screen table and the Excel export.
    // kind 'bool' columns are filtered with a picker, others with an "includes" text field.
    getTariffColumns = (): {
        label: string;
        value: (x: Tariff) => any;
        kind?: 'text' | 'bool' | 'schedule' | 'select';
        options?: string[];
        filterValue?: (x: Tariff) => string;
    }[] => {
        const { t } = this.props;

        // Scalar value with an empty-state fallback.
        const val = (v: any): any => (v === undefined || v === null || v === '' ? '—' : v);

        // Surge / time_settings flags: true/false/null (null = hérité du parent).
        const bool = (v: any): string => {
            if (v === true || v === 1) {
                return t('tariffs.surge_options.on');
            }
            if (v === false || v === 0) {
                return t('tariffs.surge_options.off');
            }
            return '—';
        };

        const slots = this.slotsLabel;

        // Prices only (used to filter scheduled columns on the amount, not the days/hours).
        const slotPrices = (arr: any): string =>
            Array.isArray(arr) && arr.length ? arr.map((s) => s.value).join(', ') : '';

        // Modifiers are stored as *_price_modifier objects holding percent/amount arrays.
        const modifiersCount = (pp: any): any => {
            const keys = ['km_price_modifier', 'minute_price_modifier', 'ride_price_modifier'];
            let count = 0;
            keys.forEach((k) => {
                const obj = pp?.[k];
                if (obj) {
                    Object.values(obj).forEach((a: any) => {
                        if (Array.isArray(a)) {
                            count += a.length;
                        }
                    });
                }
            });
            return count || '—';
        };

        return [
            {
                label: t('sets.tariff_type'),
                value: (x) => this.tariffTypeLabel(x.type),
                kind: 'select',
                options: (this.props.tariffs?.[this.props.match.params.id] || [])
                    .map((x) => this.tariffTypeLabel(x.type))
                    .filter((label, i, arr) => arr.indexOf(label) === i),
            },
            { label: t('tariffs.start_area'), value: (x) => val(x.start_area?.name) },
            { label: t('tariffs.end_area'), value: (x) => val(x.end_area?.name) },
            { label: t('tariffs.price_km'), value: (x) => val(x.pricing_params?.km_price) },
            { label: t('tariffs.price_minute'), value: (x) => val(x.pricing_params?.minute_price) },
            { label: t('tariffs.price_take'), value: (x) => val(x.pricing_params?.service_fees) },
            { label: t('tariffs.price_minute_wait'), value: (x) => val(x.pricing_params?.wait_minute_price) },
            { label: t('tariffs.free_minute_wait'), value: (x) => val(x.pricing_params?.uncharged_wait_minutes) },
            {
                label: t('tariffs.flat_price'),
                value: (x) => slots(x.pricing_params?.flat_price),
                kind: 'schedule',
                filterValue: (x) => slotPrices(x.pricing_params?.flat_price),
            },
            { label: t('tariffs.hour_price'), value: (x) => val(x.pricing_params?.hour_price) },
            { label: t('tariffs.extra_km_price'), value: (x) => val(x.pricing_params?.extra_km_price) },
            { label: t('tariffs.max_km_per_hour'), value: (x) => val(x.pricing_params?.max_km_per_hour) },
            {
                label: t('tariffs.min_price'),
                value: (x) => slots(x.pricing_params?.min_price?.asap),
                kind: 'schedule',
                filterValue: (x) => slotPrices(x.pricing_params?.min_price?.asap),
            },
            {
                label: t('tariffs.min_price_prebook'),
                value: (x) => slots(x.pricing_params?.min_price?.prebook),
                kind: 'schedule',
                filterValue: (x) => slotPrices(x.pricing_params?.min_price?.prebook),
            },
            { label: t('tariffs.modifiers.title'), value: (x) => modifiersCount(x.pricing_params) },
            {
                label: t('tariffs.price_cancellation_prebook'),
                value: (x) => val(x.pricing_params?.cancellation?.base_price_prebook),
            },
            {
                label: t('tariffs.price_cancellation_asap'),
                value: (x) => val(x.pricing_params?.cancellation?.base_price_asap),
            },
            {
                label: t('tariffs.cancellation_max_delay'),
                value: (x) => val(x.pricing_params?.cancellation?.max_delay),
            },
            {
                label: t('tariffs.cancellation_ride_price_rate'),
                value: (x) => {
                    const r = x.pricing_params?.cancellation?.ride_price_rate;
                    return r || r === 0 ? `${parseFloat((r * 100).toFixed(2))}%` : '—';
                },
            },
            {
                label: t('tariffs.surge_asap'),
                value: (x) => bool(x.pricing_params?.surge?.asap?.is_enabled),
                kind: 'bool',
            },
            {
                label: t('tariffs.surge_prebook'),
                value: (x) => bool(x.pricing_params?.surge?.prebook?.is_enabled),
                kind: 'bool',
            },
            {
                label: t('tariffs.surge_no_variation_price'),
                value: (x) => val(x.pricing_params?.surge?.prebook?.warranty_price),
            },
            {
                label: t('tariffs.time_settings.asap'),
                value: (x) => bool(x.pricing_params?.time_settings?.asap?.is_allowed),
                kind: 'bool',
            },
            {
                label: t('tariffs.time_settings.prebook'),
                value: (x) => bool(x.pricing_params?.time_settings?.prebook?.is_allowed),
                kind: 'bool',
            },
            {
                label: t('tariffs.time_settings.prebook_min_delay'),
                value: (x) => {
                    const d = x.pricing_params?.time_settings?.prebook?.min_delay;
                    return d || d === 0 ? d / 60 : '—';
                },
            },
        ];
    };

    // Export the tariffs table as a CSV named after the pricing set.
    // A UTF-8 BOM + ';' delimiter makes Excel open it directly with proper columns and accents.
    handleExportTariffs = (): void => {
        const { sets, match } = this.props;
        const id = match.params.id;
        const columns = this.getTariffColumns();
        const list = this.sortedTariffs();
        const data = sets?.[id]?.data;
        const service = data?.service?.name;
        const pricingName = data?.name || `pricing_${id}`;
        const name = service ? `${service} - ${pricingName}` : pricingName;

        const rows = list.map((x) => {
            const row: { [key: string]: any } = {};
            columns.forEach((c) => {
                row[c.label] = c.value(x);
            });
            return row;
        });

        const csv = '\uFEFF' + CSVUtils.getCSVfromData(rows, ';');
        htmlUtils.createDownloadAction(csv, 'text/csv', name);
    };

    setTariffFilter = (label: string, value: string): void => {
        this.setState((prev) => ({ tariffFilters: { ...prev.tariffFilters, [label]: value } }));
    };

    // Debounced so typing in a text filter re-renders the (potentially large) table only once
    // the user pauses, instead of on every keystroke.
    applyTariffFilterDebounced = debounce((label: string, value: string) => this.setTariffFilter(label, value), 250);

    // Rows matching every active column filter: 'bool'/'select' match exactly, others use an
    // accent-insensitive "includes". Takes the already-sorted list to avoid re-sorting per render.
    getFilteredTariffs = (columns: ReturnType<typeof this.getTariffColumns>, list: Tariff[]): Tariff[] => {
        const { tariffFilters } = this.state;
        const active = columns.filter((c) => (tariffFilters[c.label] ?? '') !== '');
        if (active.length === 0) {
            return list;
        }
        return list.filter((x) =>
            active.every((c) => {
                const filter = tariffFilters[c.label];
                const cell = c.filterValue ? c.filterValue(x) : String(c.value(x) ?? '');
                const exactMatch = c.kind === 'bool' || c.kind === 'select';
                return exactMatch
                    ? cell === filter
                    : StringUtils.normalizeForSearch(cell).includes(StringUtils.normalizeForSearch(filter));
            }),
        );
    };

    renderTariffsTable = (): JSX.Element => {
        const { t, globalClasses } = this.props;
        const { tariffFilters } = this.state;
        const columns = this.getTariffColumns();
        const list = this.sortedTariffs();
        const filtered = this.getFilteredTariffs(columns, list);
        const boolOptions = [t('tariffs.surge_options.on'), t('tariffs.surge_options.off'), '—'];

        return (
            <div className={globalClasses.block} style={{ minWidth: 0, maxWidth: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h3>
                        <b>{t('sets.tariff_list')}</b>
                    </h3>
                    {list.length > 0 && (
                        <Button
                            variant="contained"
                            color="primary"
                            className={clsx(globalClasses.btnAutoWidth, globalClasses.btnSuccess)}
                            onClick={this.handleExportTariffs}
                        >
                            {t('common:export')}
                        </Button>
                    )}
                </div>
                {list.length === 0 ? (
                    <p>{t('sets.no_tariffs')}</p>
                ) : (
                    <div style={{ width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    {columns.map((c) => (
                                        <TableCell key={c.label} style={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}>
                                            {c.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    {columns.map((c) => {
                                        const selectOptions =
                                            c.kind === 'bool'
                                                ? boolOptions
                                                : c.kind === 'select'
                                                  ? (c.options ?? [])
                                                  : null;
                                        return (
                                            <TableCell key={`filter-${c.label}`} style={{ minWidth: 130 }}>
                                                {selectOptions ? (
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        value={tariffFilters[c.label] ?? ''}
                                                        onChange={(e) => this.setTariffFilter(c.label, e.target.value)}
                                                    >
                                                        <MenuItem value="">{t('sets.filter_all')}</MenuItem>
                                                        {selectOptions.map((o) => (
                                                            <MenuItem key={o} value={o}>
                                                                {o}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                ) : (
                                                    <TextField
                                                        fullWidth
                                                        defaultValue={tariffFilters[c.label] ?? ''}
                                                        onChange={(e) =>
                                                            this.applyTariffFilterDebounced(c.label, e.target.value)
                                                        }
                                                    />
                                                )}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filtered.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={columns.length}>{t('sets.no_tariffs')}</TableCell>
                                    </TableRow>
                                ) : (
                                    filtered.map((tariff) => {
                                        const to = this.tariffEditPath(tariff);
                                        return (
                                            <TableRow
                                                key={tariff.id}
                                                hover
                                                style={{ cursor: to ? 'pointer' : 'default' }}
                                                onClick={(e) => {
                                                    if (!to) {
                                                        return;
                                                    }
                                                    // Ctrl/Cmd + left click also opens in a new tab.
                                                    if (e.ctrlKey || e.metaKey) {
                                                        window.open(to, '_blank');
                                                    } else {
                                                        this.props.history.push(to);
                                                    }
                                                }}
                                                // Prevent middle-click autoscroll so the aux click opens a new tab.
                                                onMouseDown={(e) => {
                                                    if (to && e.button === 1) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onAuxClick={(e) => {
                                                    if (to && e.button === 1) {
                                                        window.open(to, '_blank');
                                                    }
                                                }}
                                            >
                                                {columns.map((c) =>
                                                    c.kind === 'schedule' ? (
                                                        <TableCell
                                                            key={c.label}
                                                            style={{ whiteSpace: 'pre-line', minWidth: 200 }}
                                                        >
                                                            {c.value(tariff)}
                                                        </TableCell>
                                                    ) : (
                                                        <TableCell key={c.label} style={{ whiteSpace: 'nowrap' }}>
                                                            {c.value(tariff)}
                                                        </TableCell>
                                                    ),
                                                )}
                                            </TableRow>
                                        );
                                    })
                                )}
                            </TableBody>
                        </Table>
                    </div>
                )}
            </div>
        );
    };

    renderGeneralTab = (datas: PricingSetDetail): JSX.Element => {
        const { text, idc } = this.state;
        const {
            t,
            globalClasses,
            match,
            getPricingSetError,
            updateCompanyPricingSetsError,
            updateGroupPricingSetsError,
            companyToPricingSetsList,
        } = this.props;
        const id = match.params.id;

        return (
            <>
                {/* Price testing */}
                {this.renderPriceTesting()}

                <div style={{ display: 'flex' }}>
                    <div className={globalClasses.block} style={{ flex: 1, marginRight: 40 }}>
                        <h3>
                            <b>{t('sets.companies')}</b>
                        </h3>

                        <FormSubmit debounceSubmit={{ callback: this.handleAddCompanySubmit }}>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    flex: 1,
                                }}
                            >
                                <AutoFill
                                    datas={{
                                        id: 'company_name',
                                        label: t('sets.company'),
                                        minChar: 1,
                                        style: { minWidth: 200, width: '100%', flex: 1, marginRight: 8 },
                                        variant: 'outlined',
                                        formData: this.state,
                                        filter: {
                                            existingList: companyToPricingSetsList?.map((x) => x.company_id),
                                            test: (list, element) => !list.includes(element.uuid),
                                        },
                                        onChange: (idc, text, item) => {
                                            this.setState({ idc, text, company: item ?? null });
                                        },
                                        loaderPosition: 'right',
                                        api: getListCompaniesURL(),
                                    }}
                                />
                                <Button
                                    type="submit"
                                    variant="contained"
                                    style={{ marginLeft: 16, alignSelf: 'normal' }}
                                    color={text.length === 0 && idc !== -1 ? 'inherit' : 'secondary'}
                                >
                                    <Add fontSize="large" />
                                </Button>

                                <ErrorMessage payload={updateCompanyPricingSetsError} />
                                <ErrorMessage payload={updateGroupPricingSetsError} />
                            </div>
                        </FormSubmit>
                        <ErrorMessage payload={getPricingSetError} />

                        <EnhancedTable
                            onRef={(ref) => (this.tableRef = ref)}
                            headers={this.headerBuilder()}
                            type={tableRequestPoints.COMPANY_TO_PRICING_SETS}
                            filterParams={{ 'filter[pricing_set_id]': id }}
                            filterVisible={false}
                        />

                        <h3>
                            <b>{t('sets.groups')}</b>
                        </h3>
                        <EnhancedTable
                            onRef={(ref) => (this.groupTableRef = ref)}
                            headers={this.groupHeaderBuilder()}
                            type={tableRequestPoints.GROUP_TO_PRICING_SETS}
                            filterParams={{ 'filter[pricing_set_id]': id }}
                            filterVisible={false}
                        />
                    </div>
                    <div className={globalClasses.blockShadow} style={{ flex: 1, overflow: 'hidden' }}>
                        <FastTabs tabs={this.generateTabs()} />
                    </div>
                </div>
                <ActionLogs history={datas?.history} withValues allValues />
            </>
        );
    };

    render() {
        const { csvMsg } = this.state;
        const { t, sets, match, getPricingSetError } = this.props;

        const id = match.params.id;
        const payload = sets[id] || { data: {} as PricingSetDetail };
        const datas = payload.data;

        return (
            <App
                needRights={AccountRight.PRICING_MGMT}
                loading={!datas}
                header={{
                    title: datas?.name && `${datas.name} ${datas?.service ? `(${datas.service.name})` : ''}`,
                    actions: this.generateActions(datas),
                }}
            >
                <ErrorMessage payload={getPricingSetError} />
                <ErrorMessage payload={this.props.pricingSetActionsError} />
                <LCAlert onRef={(ref) => (this.alertRef = ref)} details={csvMsg} type="error" />

                <Dialog
                    onRef={(ref) => (this.deleteDialogRef = ref)}
                    dialogTitle={t('sets.delete_confirm_title')}
                    dialogTitleColor={DialogTextColor.RED}
                    description={this.deleteDescription(id)}
                    btnOKText={t('common:delete')}
                    btnOKColor={DialogTextColor.RED}
                    onOK={() => this.props.deletePricingSet(id, datas?.parent_id)}
                />
                {datas?.parent && (
                    <Typography variant="subtitle1">
                        {`${t('sets.parent')}: `}
                        <Link
                            color="secondary"
                            component={RouterLink}
                            to={`${paths.pricingManagePrices}/${datas.parent.id}`}
                        >
                            <b>{`${datas.parent.name}`}</b>
                        </Link>
                    </Typography>
                )}

                {/* CSV Upload */}
                <form>
                    <input
                        type="file"
                        id="file"
                        accept=".csv" //, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={this.onChangeFile}
                        ref={(input) => (this.inputElement = input)}
                        style={{ display: 'none' }}
                    />
                </form>

                {datas && (
                    <FastTabs
                        tabs={{
                            loadAll: true,
                            storageKey: 'pricing-view-active-tab',
                            datas: [
                                { label: t('sets.tab_general'), children: this.renderGeneralTab(datas) },
                                { label: t('sets.tab_revenue_manager'), children: this.renderTariffsTable() },
                            ],
                        }}
                    />
                )}
            </App>
        );
    }
}

const PricingPricesViewPageWithTranslation = withGlobalStyles(
    withTranslation(['pricing', 'common'])(PricingPricesViewPage),
);

const makemapStateToProps = () => {
    const getDatas = makeMemoizedGetDatas();

    const mapStateToProps = (state) => {
        return {
            companyToPricingSetsList: getDatas(state, { type: { reducer: 'sets' } }),
            sets: pricingSelectors.sets(state),
            price: pricingSelectors.price(state),
            tariffs: pricingSelectors.tariffs_list(state),
            getTariffsError: errorSelectors.getTariffsError(state),
            pricingSetActionsError: errorSelectors.pricingSetActionsError(state),
            getPricingSetError: errorSelectors.getPricingSetError(state),
            getComputePriceError: errorSelectors.getComputePriceError(state),
            updateCompanyPricingSetsError: errorSelectors.updateCompanyPricingSetsError(state),
            updateGroupPricingSetsError: errorSelectors.updateGroupPricingSetsError(state),
            prices: pricingSelectors.prices(state),
            isComputingTariff: pendingSelectors.isComputingTariff(state),
        };
    };
    return mapStateToProps;
};

const mapDispatchToProps = {
    getPricingSet: pricingActions.getPricingSet,
    getPricingSets: pricingActions.getPricingSets,
    exportPricingSet: pricingActions.exportPricingSet,
    importPricingSet: pricingActions.importPricingSet,
    deletePricingSet: pricingActions.deletePricingSet,
    createCompanyToPricingSets: pricingActions.createCompanyToPricingSets,
    createGroupToPricingSets: pricingActions.createGroupToPricingSets,
    deleteGroupToPricingSets: pricingActions.deleteGroupToPricingSets,
    deleteCompanyToPricingSets: pricingActions.deleteCompanyToPricingSets,
    computeTariff: pricingActions.computeTariff,
    resetLocalTariff: pricingActions.resetLocalTariff,
    searchTariffs: pricingActions.searchTariffs,
    deleteTariff: pricingActions.deleteTariff,
    clearError: errorActions.clearError,
};

export default connect(makemapStateToProps, mapDispatchToProps)(PricingPricesViewPageWithTranslation);
